module.exports = __webpack_public_path__ + "static/media/40_B.b208df21.png";